@if (!onkoTmi) {
  <form #tunnistamisForm="ngForm" class="teksti tunnistamistiedot">
    <div class="light-blue-text otsikko">Osakkaat, hallitus ja tosiasialliset edunsaajat</div>
    @if (isBrowsingHistory) {
      <div>
        <span style="font-size: 80%; padding: 0 5px" class="dark-gray-text">Tuntemistietojen historia ajalta {{ selectedHistorySubject.value?.paivitetty | ltimestamptime | async }}</span>
        <div style="display: flex">
          <div class="dark-gray-text">
            <app-button [disabled]="!prevActive" (click)="selectDisplayedHistory('prev')" actionId="Edellinen versio (osakkaat, hallitus, edunsaajat)"> &lt; Edellinen versio </app-button>
            <app-button [disabled]="!nextActive" (click)="selectDisplayedHistory('next')" actionId="Seuraava versio (osakkaat, hallitus, edunsaajat)"> Seuraava versio > </app-button>
          </div>
        </div>
        <app-primary-button (click)="editForm()" actionId="Avattu muokkausnäkymä: Hallitus, edunsaajat lomake auki muokattavaksi" styles="display: block; margin-top: 1em;">Muokkaa</app-primary-button>
      </div>
    } @else {
      <app-primary-button (click)="selectDisplayedHistory('init')" actionId="Katso osakkaat, hallitus, edunsaajat historiaa" styles="display: block;"> Katso historiaa </app-primary-button>
    }
    <div class="osakkaat">
      @if (commonError) {
        <div class="lemon-error">{{ commonError }}</div>
      }
      <div class="tuntemistieto-otsikko">{{ 'lemonaid-sopimus-dialog.kyc.osakkaat' | translate | async }}</div>
      @if (lomake.osakkaat().value().length > 0) {
        <div class="osakkeet-yhteismaara" [style.color]="isBrowsingHistory ? '#999' : '#000'">Osakkeiden yhteismäärä: {{ osakkeidenYhteisMaaraObservable | async | number }} kpl</div>
      }
      @if (onkoVirhe(lomake.osakkaat, 'min')) {
        <div class="lemon-error">{{ 'lemonaid-sopimus-dialog.kyc.vahintaan-yksi-osakas' | translate | async }}</div>
      }
      <div>
        @for (rivi of lomake.osakkaat; track rivi; let i = $index) {
          <div class="osakas">
            <div class="kyc-checkbox">
              <mat-checkbox [labelPosition]="'before'" [formField]="rivi.noFinnishId">{{ 'lemonaid-sopimus-dialog.kyc.ei-suomalaista-tunnusta' | translate | async }} </mat-checkbox>
            </div>
            <mat-radio-group class="kyc-radio" [class.kyc-changed]="" [formField]="rivi.onkoYritys" [style.display]="rivi.onkoYritys().disabled() ? 'none' : 'flex'">
              <mat-radio-button style="margin: 5px" [value]="false">{{ 'lemonaid-sopimus-dialog.kyc.osakas-on-luonnollinen' | translate | async }}</mat-radio-button>
              <mat-radio-button style="margin: 5px" [value]="true">{{ 'lemonaid-sopimus-dialog.kyc.osakas-on-yritys' | translate | async }}</mat-radio-button>
            </mat-radio-group>
            <div class="kyc-single-row">
              <mat-form-field class="right-margin" [class.kyc-changed]="!!historyChangesMap.get(i + 'o' + 'nimi')">
                <mat-label>{{ 'lemonaid-sopimus-dialog.kyc.nimi' | translate | async }}</mat-label>
                <input type="text" [formField]="rivi.nimi" autocomplete="nothing" matInput data-lpignore="true" />
                <mat-error>
                  @if (rivi.nimi().touched() || tunnistamisForm.submitted) {
                    @if (onkoVirhe(rivi.nimi, 'required')) {
                      {{ 'lemonaid-sopimus-dialog.kyc.nimi-required' | translate | async }}
                    }
                  }
                </mat-error>
              </mat-form-field>
              <mat-form-field class="right-margin" [class.kyc-changed]="!!historyChangesMap.get(i + 'o' + 'hetuTaiYtunnus')">
                <mat-label>{{ 'lemonaid-sopimus-dialog.kyc.hetu-ytunnus' | translate | async }}</mat-label>
                <input type="text" [formField]="rivi.hetu" autocomplete="nothing" matInput data-lpignore="true" />
                <mat-error>
                  @if (rivi.hetu().touched() || tunnistamisForm.submitted) {
                    @if (onkoVirhe(rivi.hetu, 'required')) {
                      {{ 'lemonaid-sopimus-dialog.kyc.hetu-ytunnus-required' | translate | async }}
                    }
                    @if (onkoVirhe(rivi.hetu, 'invalid')) {
                      Varoitus: hetu tai y-tunnus on virheellinen
                    }
                  }
                </mat-error>
              </mat-form-field>
              <mat-form-field class="right-margin" [style.display]="rivi.birthDate().disabled() ? 'none' : 'inline-block'">
                <mat-label>{{ 'lemonaid-sopimus-dialog.kyc.syntymaaika' | translate | async }}</mat-label>
                <input type="text" [min]="minDate" [max]="maxDate" [matDatepicker]="picker1" [formField]="rivi.birthDate" autocomplete="nothing" matInput data-lpignore="true" />
                <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                <mat-error>
                  @if (rivi.birthDate().touched() || tunnistamisForm.submitted) {
                    @if (onkoVirhe(rivi.birthDate, 'required')) {
                      {{ 'lemonaid-sopimus-dialog.kyc.syntymaaika-required' | translate | async }}
                    }
                    @if (onkoVirhe(rivi.birthDate, 'matDatepickerMin')) {
                      Liian aikainen päivämäärä
                    }
                    @if (onkoVirhe(rivi.birthDate, 'matDatepickerMax')) {
                      Liian myöhäinen päivämäärä
                    }
                  }
                </mat-error>
              </mat-form-field>
              <mat-datepicker #picker1></mat-datepicker>
              <mat-form-field [class.kyc-changed]="!!historyChangesMap.get(i + 'o' + 'osakkeita')">
                <mat-label>{{ 'lemonaid-sopimus-dialog.kyc.osakkeiden-lukumaara' | translate | async }}</mat-label>
                <input decimalNumberField matInput [formField]="rivi.osakkeita" [numberOfDecimals]="0" data-lpignore="true" />
                <mat-error>
                  @if (rivi.osakkeita().touched() || tunnistamisForm.submitted) {
                    @if (onkoVirhe(rivi.osakkeita, 'required')) {
                      {{ 'lemonaid-sopimus-dialog.kyc.osakkeiden-lukumaara-puuttuu' | translate | async }}
                    }
                    @if (onkoVirhe(rivi.osakkeita, 'min')) {
                      Vähintään yksi osake
                    }
                  }
                </mat-error>
              </mat-form-field>
            </div>
            <div class="kyc-single-row">
              <mat-form-field class="right-margin" [class.kyc-changed]="!!historyChangesMap.get(i + 'o' + 'kansallisuus')">
                <mat-label>{{ 'lemonaid-sopimus-dialog.kyc.kansallisuus' | translate | async }}</mat-label>
                <mat-select [formField]="rivi.kansallisuus">
                  @for (kansa of kansallisuudetObservable | async; track kansa) {
                    <mat-option [value]="kansa.koodi">
                      {{ kansa.nimi }}
                    </mat-option>
                  }
                </mat-select>
                <mat-error>
                  @if (rivi.kansallisuus().touched() || tunnistamisForm.submitted) {
                    @if (onkoVirhe(rivi.kansallisuus, 'required')) {
                      {{ 'lemonaid-sopimus-dialog.kyc.kansallisuus-required' | translate | async }}
                    }
                  }
                </mat-error>
              </mat-form-field>
              <mat-form-field [class.kyc-changed]="!!historyChangesMap.get(i + 'o' + 'pep')">
                <mat-label>{{ ('lemonaid-sopimus-dialog.kyc.pep' | translate | async) + ' (PEP)' }}</mat-label>
                <mat-select [formField]="rivi.pep">
                  <mat-option [value]="true">
                    {{ 'lemonaid-sopimus-dialog.kyc.kylla' | translate | async }}
                  </mat-option>
                  <mat-option [value]="false">
                    {{ 'lemonaid-sopimus-dialog.kyc.ei' | translate | async }}
                  </mat-option>
                </mat-select>
                <mat-error>
                  @if (rivi.pep().touched() || tunnistamisForm.submitted) {
                    @if (onkoVirhe(rivi.pep, 'required')) {
                      {{ 'lemonaid-sopimus-dialog.kyc.pep-required' | translate | async }}
                    }
                  }
                </mat-error>
              </mat-form-field>
            </div>
            <app-icon-button [disabled]="isBrowsingHistory" (click)="poistaOsakas(i); $event.preventDefault()" actionId="Poista osakas listalta" matIcon="delete"> </app-icon-button>
            @if (isBrowsingHistory && deletedOsakkaatText) {
              <div class="red-text">{{ deletedOsakkaatText }}</div>
            }
          </div>
        }
        <app-primary-button [disabled]="isBrowsingHistory" (click)="lisaaUusiOsakas(); $event.preventDefault()" actionId="Avattu muokkausnäkymä: Lisää uusi osakas" additionalClass="tuntemistieto-lisaa">
          {{ 'lemonaid-sopimus-dialog.kyc.lisaa-osakas' | translate | async }}
        </app-primary-button>
      </div>
      <div class="tuntemistieto-otsikko">{{ 'lemonaid-sopimus-dialog.kyc.hallitus-ja-toimitusjohtaja' | translate | async }}</div>
      @if (onkoVirhe(lomake.hallitus, 'min')) {
        <div class="lemon-error">{{ 'lemonaid-sopimus-dialog.kyc.vahintaan-yksi-hallituksen-jasenen' | translate | async }}</div>
      }
      <div>
        @for (rivi of lomake.hallitus; track rivi; let i = $index) {
          <div class="osakas">
            <div class="kyc-checkbox">
              <mat-checkbox [labelPosition]="'before'" [formField]="rivi.noFinnishId">{{ 'lemonaid-sopimus-dialog.kyc.ei-suomalaista-tunnusta' | translate | async }} </mat-checkbox>
            </div>
            <div class="kyc-single-row">
              <mat-form-field class="right-margin" [class.kyc-changed]="!!historyChangesMap.get(i + 'h' + 'nimi')">
                <mat-label>{{ 'lemonaid-sopimus-dialog.kyc.nimi' | translate | async }}</mat-label>
                <input type="text" [formField]="rivi.nimi" autocomplete="nothing" matInput data-lpignore="true" />
                <mat-error>
                  @if (rivi.nimi().touched() || tunnistamisForm.submitted) {
                    @if (onkoVirhe(rivi.nimi, 'required')) {
                      {{ 'lemonaid-sopimus-dialog.kyc.nimi-required' | translate | async }}
                    }
                  }
                </mat-error>
              </mat-form-field>
              <mat-form-field class="right-margin" [class.kyc-changed]="!!historyChangesMap.get(i + 'h' + 'hetuTaiYtunnus')">
                <mat-label>{{ 'lemonaid-sopimus-dialog.kyc.hetu' | translate | async }}</mat-label>
                <input type="text" [formField]="rivi.hetu" autocomplete="nothing" matInput data-lpignore="true" />
                <mat-error>
                  @if (rivi.hetu().touched() || tunnistamisForm.submitted) {
                    @if (onkoVirhe(rivi.hetu, 'required')) {
                      {{ 'lemonaid-sopimus-dialog.kyc.hetu-required' | translate | async }}
                    }
                    @if (onkoVirhe(rivi.hetu, 'invalid')) {
                      Varoitus: hetu on virheellinen
                    }
                  }
                </mat-error>
              </mat-form-field>
              <mat-form-field class="right-margin" [style.display]="rivi.birthDate().disabled() ? 'none' : 'inline-block'">
                <mat-label>{{ 'lemonaid-sopimus-dialog.kyc.syntymaaika' | translate | async }}</mat-label>
                <input type="text" [min]="minDate" [max]="maxDate" [matDatepicker]="picker2" [formField]="rivi.birthDate" autocomplete="nothing" matInput data-lpignore="true" />
                <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                <mat-error>
                  @if (rivi.birthDate().touched() || tunnistamisForm.submitted) {
                    @if (onkoVirhe(rivi.birthDate, 'required')) {
                      {{ 'lemonaid-sopimus-dialog.kyc.syntymaaika-required' | translate | async }}
                    }
                    @if (onkoVirhe(rivi.birthDate, 'matDatepickerMin')) {
                      Liian aikainen päivämäärä
                    }
                    @if (onkoVirhe(rivi.birthDate, 'matDatepickerMax')) {
                      Liian myöhäinen päivämäärä
                    }
                  }
                </mat-error>
              </mat-form-field>
              <mat-datepicker #picker2></mat-datepicker>
              <mat-form-field [class.kyc-changed]="!!historyChangesMap.get(i + 'h' + 'rooli')">
                <mat-label>{{ 'lemonaid-sopimus-dialog.kyc.rooli' | translate | async }}</mat-label>
                <mat-select [formField]="rivi.rooli">
                  @for (rooli of hallitusRoolitObservable | async; track rooli) {
                    <mat-option [value]="rooli.avain">
                      {{ rooli.nimi }}
                    </mat-option>
                  }
                </mat-select>
                <mat-error>
                  @if (rivi.rooli().touched() || tunnistamisForm.submitted) {
                    @if (onkoVirhe(rivi.rooli, 'required')) {
                      {{ 'lemonaid-sopimus-dialog.kyc.rooli-required' | translate | async }}
                    }
                  }
                </mat-error>
              </mat-form-field>
            </div>
            <div class="kyc-single-row">
              <mat-form-field class="right-margin" [class.kyc-changed]="!!historyChangesMap.get(i + 'h' + 'kansallisuus')">
                <mat-label>{{ 'lemonaid-sopimus-dialog.kyc.kansallisuus' | translate | async }}</mat-label>
                <mat-select [formField]="rivi.kansallisuus">
                  @for (kansa of kansallisuudetObservable | async; track kansa) {
                    <mat-option [value]="kansa.koodi">
                      {{ kansa.nimi }}
                    </mat-option>
                  }
                </mat-select>
                <mat-error>
                  @if (rivi.kansallisuus().touched() || tunnistamisForm.submitted) {
                    @if (onkoVirhe(rivi.kansallisuus, 'required')) {
                      {{ 'lemonaid-sopimus-dialog.kyc.kansallisuus-required' | translate | async }}
                    }
                  }
                </mat-error>
              </mat-form-field>
              <mat-form-field [class.kyc-changed]="!!historyChangesMap.get(i + 'h' + 'pep')">
                <mat-label>{{ ('lemonaid-sopimus-dialog.kyc.pep' | translate | async) + ' (PEP)' }}</mat-label>
                <mat-select [formField]="rivi.pep">
                  <mat-option [value]="true">
                    {{ 'lemonaid-sopimus-dialog.kyc.kylla' | translate | async }}
                  </mat-option>
                  <mat-option [value]="false">
                    {{ 'lemonaid-sopimus-dialog.kyc.ei' | translate | async }}
                  </mat-option>
                </mat-select>
                <mat-error>
                  @if (rivi.pep().touched() || tunnistamisForm.submitted) {
                    @if (onkoVirhe(rivi.pep, 'required')) {
                      {{ 'lemonaid-sopimus-dialog.kyc.pep-required' | translate | async }}
                    }
                  }
                </mat-error>
              </mat-form-field>
            </div>
            <app-icon-button [disabled]="isBrowsingHistory" (click)="poistaHallituksenJasen(i); $event.preventDefault()" actionId="Poista hallituksen jäsen" matIcon="delete"> </app-icon-button>
          </div>
        }
        @if (isBrowsingHistory && deletedHallitusText) {
          <div class="red-text">{{ deletedHallitusText }}</div>
        }
        <app-primary-button [disabled]="isBrowsingHistory" (click)="lisaaUusiHallituksenJasen(); $event.preventDefault()" actionId="Avattu muokkausnäkymä: Lisää uusi hallituksen jäsen" additionalClass="tuntemistieto-lisaa">
          {{ 'lemonaid-sopimus-dialog.kyc.lisaa-jasen' | translate | async }}
        </app-primary-button>
      </div>
      <div class="tuntemistieto-otsikko">{{ 'lemonaid-sopimus-dialog.kyc.edunsaajat' | translate | async }}</div>
      <div>
        @for (rivi of lomake.edunsaajat; track rivi; let i = $index) {
          <div class="osakas">
            <div class="kyc-checkbox">
              <mat-checkbox [labelPosition]="'before'" [formField]="rivi.noFinnishId">{{ 'lemonaid-sopimus-dialog.kyc.ei-suomalaista-tunnusta' | translate | async }} </mat-checkbox>
            </div>
            <div class="kyc-single-row">
              <mat-form-field class="right-margin" [class.kyc-changed]="!!historyChangesMap.get(i + 'e' + 'nimi')">
                <mat-label>{{ 'lemonaid-sopimus-dialog.kyc.nimi' | translate | async }}</mat-label>
                <input type="text" [formField]="rivi.nimi" autocomplete="nothing" matInput data-lpignore="true" />
                <mat-error>
                  @if (rivi.nimi().touched() || tunnistamisForm.submitted) {
                    @if (onkoVirhe(rivi.nimi, 'required')) {
                      {{ 'lemonaid-sopimus-dialog.kyc.nimi-required' | translate | async }}
                    }
                  }
                </mat-error>
              </mat-form-field>
              <mat-form-field [class.kyc-changed]="!!historyChangesMap.get(i + 'e' + 'hetuTaiYtunnus')">
                <mat-label>{{ 'lemonaid-sopimus-dialog.kyc.hetu' | translate | async }}</mat-label>
                <input type="text" [formField]="rivi.hetu" autocomplete="nothing" matInput data-lpignore="true" />
                <mat-error>
                  @if (rivi.hetu().touched() || tunnistamisForm.submitted) {
                    @if (onkoVirhe(rivi.hetu, 'required')) {
                      {{ 'lemonaid-sopimus-dialog.kyc.hetu-required' | translate | async }}
                    }
                    @if (onkoVirhe(rivi.hetu, 'invalid')) {
                      Varoitus: hetu on virheellinen
                    }
                  }
                </mat-error>
              </mat-form-field>
              <mat-form-field class="left-margin" [style.display]="rivi.birthDate().disabled() ? 'none' : 'inline-block'">
                <mat-label>{{ 'lemonaid-sopimus-dialog.kyc.syntymaaika' | translate | async }}</mat-label>
                <input type="text" [min]="minDate" [max]="maxDate" [matDatepicker]="picker3" [formField]="rivi.birthDate" autocomplete="nothing" matInput data-lpignore="true" />
                <mat-datepicker-toggle matSuffix [for]="picker3"></mat-datepicker-toggle>
                <mat-error>
                  @if (rivi.birthDate().touched() || tunnistamisForm.submitted) {
                    @if (onkoVirhe(rivi.birthDate, 'required')) {
                      {{ 'lemonaid-sopimus-dialog.kyc.syntymaaika-required' | translate | async }}
                    }
                    @if (onkoVirhe(rivi.birthDate, 'matDatepickerMin')) {
                      Liian aikainen päivämäärä
                    }
                    @if (onkoVirhe(rivi.birthDate, 'matDatepickerMax')) {
                      Liian myöhäinen päivämäärä
                    }
                  }
                </mat-error>
              </mat-form-field>
              <mat-datepicker #picker3></mat-datepicker>
            </div>
            <div class="kyc-single-row">
              <mat-form-field class="right-margin" [class.kyc-changed]="!!historyChangesMap.get(i + 'e' + 'kansallisuus')">
                <mat-label>{{ 'lemonaid-sopimus-dialog.kyc.kansallisuus' | translate | async }}</mat-label>
                <mat-select [formField]="rivi.kansallisuus">
                  @for (kansa of kansallisuudetObservable | async; track kansa) {
                    <mat-option [value]="kansa.koodi">
                      {{ kansa.nimi }}
                    </mat-option>
                  }
                </mat-select>
                <mat-error>
                  @if (rivi.kansallisuus().touched() || tunnistamisForm.submitted) {
                    @if (onkoVirhe(rivi.kansallisuus, 'required')) {
                      {{ 'lemonaid-sopimus-dialog.kyc.kansallisuus-required' | translate | async }}
                    }
                  }
                </mat-error>
              </mat-form-field>
              <mat-form-field [class.kyc-changed]="!!historyChangesMap.get(i + 'e' + 'pep')">
                <mat-label>{{ ('lemonaid-sopimus-dialog.kyc.pep' | translate | async) + ' (PEP)' }}</mat-label>
                <mat-select [formField]="rivi.pep">
                  <mat-option [value]="true">
                    {{ 'lemonaid-sopimus-dialog.kyc.kylla' | translate | async }}
                  </mat-option>
                  <mat-option [value]="false">
                    {{ 'lemonaid-sopimus-dialog.kyc.ei' | translate | async }}
                  </mat-option>
                </mat-select>
                <mat-error>
                  @if (rivi.pep().touched() || tunnistamisForm.submitted) {
                    @if (onkoVirhe(rivi.pep, 'required')) {
                      {{ 'lemonaid-sopimus-dialog.kyc.pep-required' | translate | async }}
                    }
                  }
                </mat-error>
              </mat-form-field>
            </div>
            <app-icon-button [disabled]="isBrowsingHistory" (click)="poistaEdunsaaja(i); $event.preventDefault()" actionId="Poista edunsaaja" matIcon="delete"> </app-icon-button>
          </div>
        }
        @if (isBrowsingHistory && deletedEdunsaajatText) {
          <div class="red-text">{{ deletedEdunsaajatText }}</div>
        }
        <app-primary-button [disabled]="isBrowsingHistory" (click)="lisaaUusiEdunsaaja(); $event.preventDefault()" actionId="Avattu muokkausnäkymä: Lisää uusi edunsaaja rivi" additionalClass="tuntemistieto-lisaa">
          {{ 'lemonaid-sopimus-dialog.kyc.lisaa-edunsaaja' | translate | async }}
        </app-primary-button>
      </div>
    </div>
    @if (!isBrowsingHistory) {
      <div style="margin: 60px 0 0 0">
        <!--halutaanko tallentaa näitä tietoja formista?-->
        <app-primary-button (click)="tallenna()" actionId="Tallenna tunnistamistiedot" [actionContext]="$any(lomake().value())"> Tallenna tiedot </app-primary-button>
        @if (knowYourCustomerLastUpdatedObservable | async; as knowYourCustomerLastUpdated) {
          <span style="font-size: 80%; padding-left: 20px">Tiedot tallensi viimeksi: {{ knowYourCustomerLastUpdated }}.</span>
        }
      </div>
    }
    <div style="margin-bottom: 40px; margin-top: 30px; overflow: visible; display: flex; align-items: center; width: 675px">
      <app-secondary-button (click)="vaadiTuntemistietojenPaivitysta(); $event.preventDefault()" actionId="Avasi dialogin: Vaadi tuntemistietojen päivitystä"> Vaadi tuntemistietojen päivitystä </app-secondary-button>
      @if (kycLastSeenLogObservable | async; as kycLastSeenLog) {
        <span style="font-size: 80%; padding-left: 20px; white-space: nowrap">Lomaketta katseli viimeksi {{ kycLastSeenLog.kayttajanNimi }} {{ kycLastSeenLog.seenAtString }}</span>
      }
    </div>
  </form>
}
